import {
  LayoutDashboard,
  Users,
  Monitor,
  Lock,
  Timer,
  ClipboardList,
  Activity,
  Ticket,
  UserCog,
  Settings,
  Menu,
  Moon,
  Sun,
  MonitorSmartphone,
  User,
  LogOut,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Info,
  X,
  ChevronLeft,
  ChevronRight,
  ArrowUp,
  ArrowDown
} from 'lucide-react';

// Navigation Icons
export const DashboardIcon = LayoutDashboard;
export const UsersIcon = Users;
export const AgentsIcon = Monitor;
export const SessionsIcon = Lock;
export const RateLimitsIcon = Timer;
export const AuditLogsIcon = ClipboardList;
export const HealthIcon = Activity;
export const BetaAccessIcon = Ticket;
export const AdminsIcon = UserCog;
export const SettingsIcon = Settings;

// UI Icons
export const MenuIcon = Menu;
export const MoonIcon = Moon;
export const SunIcon = Sun;
export const SystemIcon = MonitorSmartphone; // or Monitor
export const UserIcon = User;
export const LogoutIcon = LogOut;
export const CloseIcon = X;
export const ChevronLeftIcon = ChevronLeft;
export const ChevronRightIcon = ChevronRight;
export const ArrowUpIcon = ArrowUp;
export const ArrowDownIcon = ArrowDown;

// Toast/Status Icons
export const SuccessIcon = CheckCircle;
export const ErrorIcon = XCircle;
export const WarningIcon = AlertTriangle;
export const InfoIcon = Info;
